import React from 'react';
import { Icon } from './Icon.js';
export const IconMessageFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m9.25.501H2.75C1.233.501,0,1.735,0,3.251v3.5c0,1.517,1.233,2.75,2.75,2.75h.25v1.75c0,.291.168.556.432.679.102.047.21.071.318.071.172,0,.343-.059.48-.174l2.792-2.326h2.229c1.517,0,2.75-1.233,2.75-2.75v-3.5c0-1.517-1.233-2.75-2.75-2.75Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconMessageFill12.js.map